module.exports = __webpack_public_path__ + "img/uploadcardoc.d0c67d51.webp";